class HeaderManagerSingleton {
	internalAdditionalState = null;
	subscribers = [];

	// subheader: string
	// cta: {
	// 	question
	// 	callToAction {
	// 		name:
	// 		to:
	// 	}
	// }
	set headerProperties({ subheader = null, cta = null, back = true } = {}) {
		this.internalAdditionalState = {
			back,
			subheader,
			cta,
		};

		// Let everyone know about the change.
		for (const subscriber of this.subscribers) {
			subscriber(this.internalAdditionalState);
		}
	}

	get headerProperties() {
		return this.internalAdditionalState;
	}

	subscribe(callback) {
		if (this.subscribers.indexOf(callback) < 0) {
			this.subscribers.push(callback);
		}
	}

	unsubscribe(callback) {
		this.subscribers = this.subscribers.filter(subscriber => subscriber !== callback);
	}
}

export const HeaderManager = new HeaderManagerSingleton();



// WEBPACK FOOTER //
// ./src/managers/headerManager.js